export default __webpack_public_path__ + "static/media/hero-home-consumer-right-us-en.b1e9e2ba.gif";